// ImportHistoryModal.jsx
import { Dialog } from 'primereact/dialog';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useQuery } from '@tanstack/react-query';
import { getImportHistory } from '../services/baremos';
import { useState } from 'react';
import { Button } from 'primereact/button';

export default function ImportHistoryModal({ visible, onHide, clientId, medicalCenterId }) {
  const [currentStep, setCurrentStep] = useState('list'); // 'list' o 'details'
  const [selectedLog, setSelectedLog] = useState(null);

  const { data: history = [], isLoading } = useQuery({
    queryKey: ['importHistory', clientId, medicalCenterId],
    queryFn: () => getImportHistory(clientId, medicalCenterId),
    enabled: visible,
  });

  const formatDate = (date) => new Date(date).toLocaleString('es-ES');

  const handleViewDetails = (log) => {
    setSelectedLog(log);
    setCurrentStep('details');
  };

  const handleBackToList = () => {
    setCurrentStep('list');
    setSelectedLog(null);
  };

  return (
    <Dialog
      header={
        currentStep === 'list'
          ? 'Historial de Importaciones'
          : `Detalles: ${selectedLog?.file_name || 'Cargando'}`
      }
      visible={visible}
      style={{ width: '80vw' }}
      onHide={onHide}
      maximizable
    >
      {/* Paso 1: Listado de importaciones */}
      {currentStep === 'list' && (
        <DataTable
          value={history}
          loading={isLoading}
          emptyMessage="No hay importaciones registradas."
          paginator
          rows={10}
          dataKey="id"
        >
          <Column field="user" header="Usuario" />
          <Column field="file_name" header="Archivo" />
          <Column field="medical_center_name" header="Centro Médico" />
          <Column
            header="Actualizados"
            body={(row) => `${row.total_updated} precios`}
            style={{ width: '140px' }}
          />
          <Column
            field="imported_at"
            header="Fecha"
            body={(row) => formatDate(row.imported_at)}
            style={{ width: '180px' }}
          />
          <Column
            header="Acciones"
            body={(row) => (
              <Button
                label="Ver detalles"
                size="small"
                onClick={() => handleViewDetails(row)}
              />
            )}
            style={{ width: '120px', textAlign: 'center' }}
          />
        </DataTable>
      )}

      {/* Paso 2: Detalles de una importación */}
      {currentStep === 'details' && selectedLog && (
        <div className="p-2">
          <div className="mb-3">
            <Button
              label="← Volver al historial"
              icon="pi pi-arrow-left"
              text
              onClick={handleBackToList}
              className="p-button-sm"
            />
          </div>

          <h5 className="mb-3">Cambios en precios ({selectedLog.total_updated})</h5>

          {selectedLog.changes_summary && selectedLog.changes_summary.length > 0 ? (
            <DataTable
              value={selectedLog.changes_summary}
              size="small"
              responsiveLayout="scroll"
              emptyMessage="No hubo cambios en precios."
              paginator
              rows={15}
              className="shadow-none"
            >
              <Column
                field="requirement"
                header="Servicio"
                style={{ minWidth: '220px' }}
              />
              
              <Column
                header="Precio Anterior"
                body={(row) => (
                    <span style={{ color: 'red' }}>
                    {parseFloat(row.old_price).toFixed(2)}
                    </span>
                )}
                
                style={{ width: '140px' }}
              />
              <Column
                header="Nuevo Precio"
                body={(row) => parseFloat(row.new_price).toFixed(2)}
                style={{ width: '140px' }}
              />
            </DataTable>
          ) : (
            <div className="p-3 bg-gray-100 border-round">
              <p className="m-0 text-muted">No se detectaron cambios en precios durante esta importación.</p>
            </div>
          )}
        </div>
      )}
    </Dialog>
  );
}